import { useContext } from "react";
import { UploaderContext } from "../../providers/uploaders/UploaderProvider";

export function useUploader() {
  return useContext(UploaderContext);
}
